import axios from 'axios'

const service = axios.create(
    {
        baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/api/' : window.location.origin + '/api/',
        timeout: process.env.NODE_ENV === 'development' ? 0 : 15000,
        withCredentials: true
    })

service.interceptors.request.use(
    async config => {
        config.headers.post['Content-Type'] = 'application/json multipart/form-data'
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        return Promise.resolve(response.data)
    },
    async error => {
        if (error.response) {
            const {status: statusKod} = error.response
            if (statusKod === 400) {
                if (error.response && error.response.data && error.response.data.message) {
                    window.lokum.$bvToast.toast(error.response.data.message, {
                        title: 'Hata',
                        autoHideDelay: 5000,
                        variant: 'danger',
                        solid: true
                    })
                }
            } else if (statusKod >= 500) {
                window.lokum.$bvToast.toast('Sunucu Hatası Oluştu', {
                    title: 'Hata',
                    autoHideDelay: 5000,
                    variant: 'danger',
                    solid: true
                })
            } else {
                window.lokum.$bvToast.toast('Bilinmeyen Bir Hata Oluştu', {
                    title: 'Hata',
                    autoHideDelay: 5000,
                    variant: 'danger',
                    solid: true
                })
            }
        } else {
            window.lokum.$bvToast.toast('İletişim Hatası Oluştu', {
                title: 'Hata',
                autoHideDelay: 5000,
                variant: 'danger',
                solid: true
            })
        }
        return Promise.reject(error.response)
    }
)

export default service